import Dropkick from "dropkickjs";

function onCustomSelecteCountryChange(country) {

    const form = document.querySelector(".js-country-form");
    if (form) {
        if (country === "poland") {
            form.action = form.dataset.poland;
            form.classList.remove("city-es");
            form.classList.add("city-pl");
        } else {
            form.action = form.dataset.abroad;
            form.classList.add("city-es");
            form.classList.remove("city-pl");
        }
    }
}

function onCustomSelectChange(el) {
    el.classList.add("custom-select-v2--active");
    if (el.classList.contains("js-country-changer")) {
        onCustomSelecteCountryChange(el.querySelector("select").value);
    }
}

function onCustomSelectInitialize(el) {
    const value = el.querySelector("select").value;
    if (value && value !== String.fromCharCode(160)) {
        el.classList.add("custom-select-v2--active");
    }
}

[...document.querySelectorAll(".custom-select-v2")].map(
    (el) => new Dropkick(el.querySelector("select"), { mobile: true, change: () => onCustomSelectChange(el),  initialize: () => onCustomSelectInitialize(el) })
);
